import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, User, Heart, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { resolveImageUrl } from '../config';
import './Header.css';

const Header = ({ wishlistCount = 3, cartCount = 2, onCartClick }) => {
  const { user, logout, branding } = useCart();
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <header className="main-header-bg">
      <div className="container header-container">
        {/* Logo */}
        <Link to="/" className="logo-wrapper">
          <div className="logo-icon-container">
            <img 
              src={resolveImageUrl(branding.logoUrl)} 
              alt={`${branding.brandName} Logo`} 
              className="logo-img" 
            />
          </div>
          <div className="logo-text-area">
            <span className="logo-title">{branding.brandName}</span>
            <span className="logo-tagline">{branding.tagline}</span>
          </div>
        </Link>

        {/* Search Bar */}
        <form onSubmit={handleSearch} className="search-bar-form">
          <div className="search-bar-wrapper">
            <input
              type="text"
              placeholder="Search for nuts, makhana, dry fruits..."
              className="search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button type="submit" className="search-button" aria-label="Search">
              <Search size={18} />
            </button>
          </div>
        </form>

        {/* Action Icons */}
        <div className="header-actions">
          {user ? (
            <button 
              className="action-btn-item" 
              onClick={logout} 
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit', color: 'inherit', textAlign: 'inherit' }}
            >
              <div className="action-btn-icon-wrapper">
                <User size={20} style={{ color: 'var(--primary-green)' }} />
              </div>
              <span>Logout ({user.name.split(' ')[0]})</span>
            </button>
          ) : (
            <Link to="/login" className="action-btn-item">
              <div className="action-btn-icon-wrapper">
                <User size={20} />
              </div>
              <span>Login / Register</span>
            </Link>
          )}

          <Link to="/wishlist" className="action-btn-item">
            <div className="action-btn-icon-wrapper">
              <Heart size={20} />
              {wishlistCount > 0 && (
                <span className="badge-count">{wishlistCount}</span>
              )}
            </div>
            <span>Wishlist</span>
          </Link>

          <a 
            href="#cart" 
            className="action-btn-item"
            onClick={(e) => {
              e.preventDefault();
              if (onCartClick) onCartClick();
            }}
          >
            <div className="action-btn-icon-wrapper">
              <ShoppingBag size={20} />
              {cartCount > 0 && (
                <span className="badge-count">{cartCount}</span>
              )}
            </div>
            <span>Cart</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
